import i18next from "i18next";
import React from "react";
import { Trans } from "react-i18next";
import ValidationError from "./ValidationError";
import Utility from "../utility/Utility";

type Props = {
  label?: string;
  label_key: string;
  maxLength?: number;
  type: string;
  id: string;
  defaultValue?: any;
  onChange?: any;
  onBlur?: any;
  error?: any;
  value?: any;
  disabled?: any;
  mandate?: boolean;
  dynamicPlaceHolder?: string;
  source?: string;
  relation?: string;
};

const TextInput = (props: Props) => {
  const placeholderStr: string =
    props.dynamicPlaceHolder || i18next.t(`placeholder.${props.label_key}`);

  /**
   * this function is used to prevent the user from entering the
   * characters 'e', 'E', '+', '-' in the input field of type number.`
   * @param e Event
   */
  const handlekeyDown = (e: any) => {
    if (e.key === "e" || e.key === "E" || e.key === "+" || e.key === "-") {
      e.preventDefault();
    }
  };

  const handleMaxLength = (e: any) => {
    if (e.target.value.length > e.target.maxLength) {
      e.target.value = e.target.value.slice(0, e.target.maxLength);
    }
  };

  // This function disables the property to increment/decremet numbers on scrolling over input type "number".
  const disableScrollInput = (e: any) => {
    e.target.blur();
  };

  // This function disables the property to increment/decremet numbers using up/down arrow keys on input type "number".
  const disableUpDownArrowsInput = (e: any) => {
    if (e.which == 38 || e.which == 40) {
      e.preventDefault();
    }
  };

  return (
    <>
      <label className="label-1">
        {props?.label_key ? (
          <>
            <Trans i18nKey={props?.label_key}></Trans>{" "}
            {props.mandate && <span className="mandetory">*</span>}
          </>
        ) : (
          props.label
        )}
      </label>
      {props.type === "number" && props?.maxLength !== null ? (
        <>
          <input
            id={props.id}
            onInput={handleMaxLength}
            onChange={props?.onChange}
            onKeyDownCapture={handlekeyDown}
            onBlur={props?.onBlur}
            type={"number"}
            maxLength={props?.maxLength}
            placeholder={placeholderStr}
            defaultValue={
              props?.defaultValue ? props?.defaultValue : props?.value
            }
            value={props?.defaultValue ? props?.defaultValue : props?.value}
            disabled={props?.disabled === undefined ? false : !props.disabled}
            className={props?.disabled === undefined ? "" : "text-capitalize"}
            onWheel={e => disableScrollInput(e)}
            onKeyDown={e => disableUpDownArrowsInput(e)}
          />
        </>
      ) : (
        <>
          <input
            id={props.id}
            onChange={props?.onChange}
            onBlur={props?.onBlur}
            type={
              props?.type?.toLowerCase() === "idnumber" ? "text" : props.type
            }
            maxLength={props?.maxLength}
            placeholder={placeholderStr}
            defaultValue={
              props?.defaultValue ? props?.defaultValue : props?.value
            }
            value={props?.defaultValue ? props?.defaultValue : props?.value}
            disabled={props?.disabled === undefined ? false : !props.disabled}
            className={props.disabled ? "" : "text-capitalize"}
            onInput={
              props?.type?.toLowerCase() === "idnumber"
                ? Utility.englishOnlyWitoutSpace
                : props?.type?.toLowerCase() === "text" &&
                  props?.label_key?.toLowerCase() !== "patient_name" &&
                  props?.label_key?.toLowerCase() !== "first_name" &&
                  props?.label_key?.toLowerCase() !== "last_name" &&
                  props?.label_key?.toLowerCase() !== "relative_name"
                ? Utility.addressFieldEnglish
                : Utility.englishOnlyWithSpace
            }
          />
        </>
      )}
      {props?.relation === "self" ? (
        ""
      ) : (
        <ValidationError error_key={props?.error || ""} />
      )}
    </>
  );
};

export default TextInput;
